import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Box from "@mui/material/Box";
import MuiLink from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { KycUserMenu } from "./KycUserMenu";

interface KycSidePanelProps {
  onBack: () => void;
}

export function KycSidePanel({ onBack }: KycSidePanelProps) {
  return (
    <Stack
      component="aside"
      sx={{
        flexShrink: 0,
        width: { lg: 600 },
        height: { lg: "100vh" },
        position: { lg: "sticky" },
        top: 0,
        justifyContent: { lg: "space-between" },
        px: { xs: 1.5, lg: 5 },
        py: { xs: 1, lg: 5 },
        bgcolor: "primary.800",
        color: "common.white",
      }}
    >
      <Stack
        direction="row"
        sx={{ alignItems: "center", justifyContent: "space-between", gap: 2 }}
      >
        <MuiLink
          component="button"
          type="button"
          onClick={onBack}
          data-testid="kyc-back-to-dashboard-link"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
            color: "inherit",
            textDecorationLine: "none",
          }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: { xs: 16, lg: 24 } }} />
          <Typography
            variant="body2"
            sx={{ typography: { xs: "body3", lg: "body2" }, fontWeight: 700 }}
          >
            Back to{" "}
            <Box
              component="span"
              sx={{ display: { xs: "none", lg: "inline" } }}
            >
              Trustap{" "}
            </Box>
            dashboard
          </Typography>
        </MuiLink>
        <KycUserMenu />
      </Stack>
      <Stack sx={{ display: { xs: "none", lg: "flex" }, gap: 2.5 }}>
        <Box
          component="img"
          src="/logo_white.svg"
          alt="Trustap"
          sx={{ display: "block", width: 196, my: "6px" }}
        />
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, letterSpacing: "0.1px" }}
        >
          Trustap partners with Stripe to verify your identity and keep every
          transaction secure.
        </Typography>
      </Stack>
      <Box sx={{ display: { xs: "none", lg: "block" }, height: 24 }} />
    </Stack>
  );
}
